import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux"
import firebase from 'firebase'
import './App.css';

import store from './store'
import context from './context'
import { PrivateRoute } from './helpers/PrivatePage'

import Home from './containers/Home'
import NotFound from './containers/NoMatch'
import AddData from './containers/AddData'
import EditData from './containers/EditData'
import Register from './containers/Register'
import Login from './containers/Login'

class App extends Component {
  state = {
    user: ''
  }

  componentDidMount() {
    this.getLoggedInUser()
  }

  getLoggedInUser = () => {
    firebase.auth().onAuthStateChanged( user => {
      if (user) {
        this.setState({
          user: user.uid
        })
      }
    })
  }

  setUser = (id, props) => {
    this.setState({
      user: id
    })

    props.history.push('/')
  }

  unsetUser = () => {
    this.setState({
      user: ''
    })
  }

  render() {
    return (
      <Provider store={ store }>
        <context.Provider value={ { user: this.state.user, logout: this.unsetUser, setUser: this.setUser } }>
          <Router>
            <div>
              <Switch>
                <Route exact path="/" component={ Home }/>
                <PrivateRoute path="/adddata" component={ AddData } isLogin={this.state.user}/>
                <PrivateRoute path="/edit/:id" component ={ EditData } isLogin={this.state.user}/>
                <Route path="/register" component={ Register }/>
                <Route path="/login" component={ Login }/>
                <Route component={ NotFound }/>
              </Switch>
            </div>
          </Router>
        </context.Provider>
      </Provider>
    );
  }
}

export default App;
